import React, { Component } from "react";
import { isEmpty } from "ramda";
import moment from 'moment';
import {
	css
}
	from 'emotion';
import {
	Card,
	Button
}
	from "@maxmilhas/hangar-components-atomic/public";
import {
	gridGutter,
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import CancellationInfoModal from "./CancellationInfoModal";
import CancellationChangeByCiaModal from "./CancellationChangeByCiaModal";
import {
	$,
	getFlightsList,
	getPassengerList
}
	from "../../../shared/utils";
import BaseAlert from "./base-components/BaseAlert";
import PasswordModal from './organisms/PasswordModal';
import CancellationModal from './CancellationModal';
import {
	cancelOrder,
} from "../../../shared/requests-api";
import ChangeInfoModal from "./organisms/ChangeInfoModal";

const titlePadding = `
    padding-top: ${gridGutter}px;
`;

class CancellationBudgetOptions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			cancellationInfoModalOpen: false,
			confirmPasswordModalOpen: false,
			changeInfoModalOpen: false,
			cancellationChangeByCiaOpen: false,
			messageModalOpen: false,
			messageScenario: null,
			open: 'cancel',
			selectedType: null
		};
		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.callback = this.callback.bind(this);
		this.togglePasswordModal = this.togglePasswordModal.bind(this);
		this.toggleMessageModal = this.toggleMessageModal.bind(this);
		this.submit = this.submit.bind(this);
		this.openCard = this.openCard.bind(this);
	}

	openModal(type) {
		$("body").classList.add("body-lock");

		if (type === 'changeByCia') {
			this.setState({
				cancellationChangeByCiaOpen: true,
				selectedType: type
			});
			return;
		}

		if (type === 'change') {
			this.setState({
				changeInfoModalOpen: true,
				selectedType: type
			});
			return;
		}

		this.setState({
			cancellationInfoModalOpen: true,
			selectedType: type
		});
		return;
	}

	closeModal() {
		$("body").classList.remove("body-lock");

		this.setState({
			cancellationInfoModalOpen: false,
			changeInfoModalOpen: false,
			cancellationChangeByCiaOpen: false,
			selectedType: null
		});
	}

	callback(infoData) {
		this.setState({
			infoData
		});
		this.togglePasswordModal();
	}

	togglePasswordModal() {
		const {
			confirmPasswordModalOpen
		} = this.state;
		$("body").classList.remove("body-lock");
		if (!confirmPasswordModalOpen) {
			$("body").classList.add("body-lock");
		}
		this.setState({
			confirmPasswordModalOpen: !confirmPasswordModalOpen
		});
	}

	submit(data) {
		const submitData = data;
		submitData.infoData = this.state.infoData;
		cancelOrder(
			submitData.loginToken,
			submitData.token,
			submitData.orderCode,
			null,
			submitData.infoData
		).then(response => {
			this.togglePasswordModal();
			this.toggleMessageModal("Success");
		}).catch(err => {
			if (err.response.data.type == "InvalidChargeBackValueException") {
				this.togglePasswordModal();
				this.toggleMessageModal("InvalidChargeBackValueException");
			} else {
				this.toggleMessageModal("GenericException");
			}
		});
	}

	toggleMessageModal(scenario) {
		const {
			messageModalOpen
		} = this.state;
		$("body").classList.remove("body-lock");
		if (!messageModalOpen) {
			$("body").classList.add("body-lock");
		}
		this.setState({
			messageModalOpen: !messageModalOpen,
			messageScenario: {
				type: scenario
			}
		});
	}

	openCard(type) {
		if (this.state.open === type) {
			this.setState({
				open: null
			});
			return;
		}
		this.setState({
			open: type
		})
	}

	hasCancellationBudgetOption() {
		const { order } = this.props;
		const cancellationData = order.cancellationData;
		const {
			order: {
				billing: {
					total_credit
				}
			}
		} = order;
		/**
		 * Em casos onde exista uma parte ou toda a compra realizada por créditos devemos mostrar 
		 * as opções de orçamento para cancelamento.
		 */
		if (parseFloat(total_credit) > 0 || parseFloat(total_credit) > 0) return true;

		/*
		Em casos onde não existe um calculo de cancelamento
		ou em casos onde o status do voo é alterado pela cia 
		é permitido solicitar orçamento de cancelamento.
		*/
		if (!cancellationData || order.order.status === 'CHANGE_BY_CIA') {
			return true;
		}
		/*
		Se existe calculo de cancelamento mas é inviavel
		não é permitido solicitar orçamento de cancelamento.
		*/
		const chargebackValue = cancellationData.billing.chargebackValue;
		if (chargebackValue < 0) {
			return false;
		}
		/*
		Em casos onde o custo para cancelamento é diferente da taxa maxmilhas 
		é permitido solicitar orçamento de cancelamento.
		*/
		const $ruleCancellationCoustIsNotMM = (cancellationData.coust !== 'maxmilhas');
		/*
		Em casos de voos para 1 passageiro e 1 trecho onde já exista um 
		calculo de cancelamento total não é permitido solicitar orçamento de cancelamento.
		*/
		const flights = getFlightsList(order.flights);
		const passengers = getPassengerList(order.passengers);
		const $ruleCheckBudgetForThis = (flights.length > 1 || passengers.length > 1);
		return $ruleCancellationCoustIsNotMM && $ruleCheckBudgetForThis;
	}

	getOptions() {
		let options = [];
		if (this.props.order.status === 'CHANGE_BY_CIA') {
			return [
				{
					type: "changeByCia",
					label: "Alteração feita pela companhia aérea",
					isOpen: true,
					text: "",
					textButton: "Solicite aqui"
				}
			];
		}
		let cancelOption = {
			type: "cancel",
			label: "Orçamento de cancelamento parcial",
			isOpen: true,
			text:
				"Precisa cancelar apenas um passageiro ou um trecho (ida ou volta) do seu voo? Clique no botão abaixo para solicitar o orçamento para o cancelamento parcial desta viagem."
		};

		if (!this.props.order.cancellationData) {
			cancelOption.label = "Orçamento de cancelamento";
			cancelOption.text =
				"Se você não utilizou sua passagem ou não irá mais viajar, clique no botão abaixo para solicitar o orçamento para o cancelamento total ou parcial do seu voo.";
		}

		if (this.hasCancellationBudgetOption()) {
			options.push(cancelOption);
		}

		if (this.props.order.isOTA && (!this.props.order.cancellationData || this.props.order.cancellationData.changeIsEnabled)) {
			options.push({
				type: "change",
				label: "Orçamento de remarcação",
				text:
					"Para alterar a data ou o horário da sua viagem, clique no botão abaixo para solicitar o orçamento de remarcação do seu voo. Ah! Vale lembrar que não é possível alterar o nome do titular da passagem. Ou seja, a troca de passageiros não pode ser feita. Combinado? "
			});
		}

		if (false) {
			options.push({
				type: "changeByDisease",
				label: "Doença",
				text:
					"Se o seu concurso teve a data alterada, podemos verificar na companhia aérea se é possível isentar as taxas de cancelamento ou remarcação. Para isso, você precisa encaminhar pra gente o comprovante individual de inscrição, o edital do concurso, o edital de adiamento do concurso e uma cópia do seu documento de identificação com foto. Mas, atenção! A solicitação deve ser feita com antecedência mínima de 48 horas do horário previsto para o voo. Assim que você nos enviar toda a documentação, vamos conferir as condições de alteração do voo na companhia aérea."
			});
			options.push({
				type: "changeByPublicTender",
				label: "Concurso Público",
				text:
					"Não conseguiu viajar por motivo de doença? As companhias aéreas permitem a isenção de taxas e abrem exceções quando o passageiro apresenta doenças infectocontagiosas. Neste caso, precisamos que você envie pra gente o atestado médico, com o CID da doença e a informação de que não poderá embarcar neste voo por este motivo. Assim que você nos enviar toda a documentação, vamos conferir as condições de alteração do voo na companhia aérea. "
			});
		}

		return options;
	}

	render() {
		const options = this.getOptions();
		const budgetRequest = this.props.order.budgetRequest;
		const hasBudgetRequest = !(isEmpty(budgetRequest));
		return (
			<React.Fragment>
				{(options.length > 0) && <React.Fragment>
					{this.props.order.cancellationData && !this.props.hideTitle && <h1 className={`subtitle ${css`${titlePadding}`}`}>
						Você também tem esta opção:
					</h1>}
					{(hasBudgetRequest && !!budgetRequest) &&
						<BaseAlert
							visible={hasBudgetRequest}
						>
							<strong>Atenção!</strong>
							Você já solicitou um orçamento para essa passagem.
							{`Para novas solicitações responda ao e-mail que foi enviado para ${budgetRequest.email} no dia ${moment(budgetRequest.createdAt, "Y-MM-D h:mm:ss").format('DD/MM/Y')}.`}
						</BaseAlert>
					}
					{options.map((option, key) => (
						<Card
							key={key}
							title={option.label}
							isOpen={(this.state.open === option.type)}
							onClick={() => this.openCard(option.type)}
							type="accordion"
						>
							<p>{option.text}</p>
							<Button
								disabled={hasBudgetRequest}
								outline={0}
								onClick={() => this.openModal(option.type)}
								data-action="my-trips-cancellation-budget">
								{!option.textButton ? "Solicitar orçamento" : option.textButton}
							</Button>
						</Card>
					))}
					<CancellationInfoModal
						type={this.state.selectedType}
						open={this.state.cancellationInfoModalOpen}
						closeModal={this.closeModal}
						callback={this.callback}
						flights={this.props.order.flights}
						passengers={this.props.order.passengers}
						enableTotalCancel={!this.props.order.cancellationData}
					/>
					<CancellationChangeByCiaModal
						type={this.state.selectedType}
						open={this.state.cancellationChangeByCiaOpen}
						closeModal={this.closeModal}
						callback={this.callback}
						flights={this.props.order.flights}
						passengers={this.props.order.passengers}
					/>
					<ChangeInfoModal
						type={this.state.selectedType}
						open={this.state.changeInfoModalOpen}
						closeModal={this.closeModal}
						callback={this.callback}
						flights={this.props.order.flights}
						passengers={this.props.order.passengers}
						enableTotalCancel={true}
					/>

					<PasswordModal
						open={this.state.confirmPasswordModalOpen}
						closeModal={this.togglePasswordModal}
						order={this.props.order.order}
						token={this.props.order.token}
						onSubmit={this.submit}
					/>
				</React.Fragment>}
				<div
					className={`cancellation-modal tingle-modal ${this.state.messageModalOpen ? "tingle-modal--visible" : ""}`}
				>
					<CancellationModal
						open={this.state.messageModalOpen}
						scenario={this.state.messageScenario}
						typeCancel="budget"
						closeModal={this.toggleMessageModal}
						btnAction={this.toggleMessageModal}
					/>
				</div>
			</React.Fragment>
		);
	}
}

export default CancellationBudgetOptions;
